<main class="s-siteContainer">

  <nav class="c-path" aria-label="breadcrumb" *ngIf="center">
    <div class="l-container">
      <ul class="c-path__list">
        <li><a [routerLink]="['/']" translate>Naslovnica</a></li>
        <li><a [routerLink]="['/courses/centers']">Edukacijski centri</a></li>
        <li class="is-active" aria-current="page"><a>{{center.name}}</a></li>
      </ul>
    </div>
  </nav>

  <div class="c-media__placeholder is-2:1 is-loading" *ngIf="!center"></div>

  <section id="hero-container" class="c-hero" *ngIf="center">
    <div class="l-container">
      <div class="l-grid">
        <div class="l-col lg:5 md:6 sm:12">
          <div class="c-hero__body">
            <h1 class="c-hero__title">{{center.name}}</h1>
            <figure class="c-hero__logo">
              <img [src]="center.logo_image | file:'image':'local'" [alt]="center.name">
            </figure>
            <p class="c-hero__desc">
              {{center.description}}
            </p>
            <div class="c-hero__cta" *ngIf="!user && user !== undefined">
              <a [routerLink]="['/login']" [queryParamsHandling]="'preserve'" class="c-btn is-primary is-outlined" translate>Prijavite se</a>
              <a [routerLink]="['/registration']" [queryParamsHandling]="'preserve'" class="c-btn is-primary" translate>Registrirajte se</a>
            </div>
          </div>
        </div>
        <div app-hero-image class="l-col lg:6 sm:12"
             [overrideImage]="center.banner_image ? (center.banner_image | file:'image':'local') : null"
             [alt]="center.short_name"></div>
      </div>
    </div>
  </section>

  <div class="s-section">
    <div class="l-container">

      <div class="l-grid l-grid--40">

        <div class="l-col lg:3 md:12">

          <div class="c-filter js-collapsible is-open">
            <button class="c-filter__title js-collapsible__toggle" id="ft-1" aria-controls="ft-1" aria-expanded="true" translate>
              Prema bodovima
            </button>
            <div class="c-filter__panel js-collapsible__panel" role="region" id="fp-1" aria-labelledby="ft-1"
                 aria-hidden="false">

              <div class="c-filter__panel_item">
                <div class="c-check">
                  <input type="checkbox" class="e-checkbox" name="f1" id="f1-1" [checked]="isPointsChecked(1)"
                         (click)="togglePoints(1)" [disabled]="withPointsCount === 0">
                  <label for="f1-1">
                    {{'Bodovani tečajevi' | translate}} <span *ngIf="withPointsCount !== undefined">({{withPointsCount}})</span>
                  </label>
                </div>
              </div>

              <div class="c-filter__panel_item">
                <div class="c-check">
                  <input type="checkbox" class="e-checkbox" name="f1" id="f1-2" [checked]="isPointsChecked(0)"
                         (click)="togglePoints(0)" [disabled]="withoutPointsCount === 0">
                  <label for="f1-2">
                    {{'Nebodovani tečajevi' | translate}} <span *ngIf="withoutPointsCount !== undefined">({{withoutPointsCount}})</span>
                  </label>
                </div>
              </div>

            </div>
          </div>

          <div class="c-filter js-collapsible is-open" *ngIf="center?.categories && center?.categories.length > 0">
            <button class="c-filter__title js-collapsible__toggle" id="ft-2" aria-controls="ft-2" aria-expanded="true" translate>
              Kategorija tečaja
            </button>
            <div class="c-filter__panel js-collapsible__panel" role="region" id="fp-2" aria-labelledby="ft-2"
                 aria-hidden="false">

              <div class="c-filter__panel_item" *ngFor="let category of center.categories;let i = index">
                <div class="c-check" *ngIf="category.enabled">
                  <input type="checkbox" class="e-checkbox" name="f2" [id]="'f2-' + i"
                         [checked]="isCategoryChecked(category)"
                         (click)="toggleCategory(category)">
                  <label [for]="'f2-' + i">
                    {{category.name}} <span *ngIf="category.course_ids">({{category.course_ids.split(',').length}}
                    )</span>
                  </label>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div id="center-courses-container" class="l-col lg:9 md:12">

          <div class="c-media__placeholder l-grid l-grid--40 is-2:1 is-loading" *ngIf="loading"></div>

          <div class="l-grid l-grid--40" *ngIf="!loading">

            <div class="l-col lg:4 sm:6 xs:12" *ngFor="let course of courses">
              <article app-card class="c-card" [title]="course.title"
                       [imageUrl]="(course.mainImage) | file:'image':'lms':640"
                       [tags]="courseUtil.courseTypes(course)"
                       [infoTags]="courseUtil.courseInfo(course)"
                       [link]="['/courses', course.urlSlug]"
                       [progress]="course.progress"
                       [completed]="course.enrolment?.status === 'COMPLETED'"
                       [disabled]="courseUtil.isCourseDisabledForUser(course, user)">
              </article>
            </div>

            <div app-pagination class="l-col lg:12" *ngIf="totalPages > 1" [currentPage]="selectedPage"
                 [totalPages]="totalPages"></div>

          </div>

        </div>

      </div>

    </div>
  </div>

  <div class="s-section is-divided" *ngIf="center && (center.sponsor_description || center.sponsor_media)">
    <div class="l-container">

      <div class="l-grid l-grid--40 u-space-between">

        <div class="l-col lg:5 xs:12 has-align-center">
          <h2>{{'Više o' | translate}} {{center.short_name?.toUpperCase()}}</h2>
          <div class="c-editor">
            <p>{{center.sponsor_description}}</p>
          </div>
        </div>

        <div class="l-col lg:6 xs:12">
          <figure class="c-media">
            <div class="c-media__placeholder">
              <img *ngIf="isMediaImage(center.sponsor_media)" [src]="center.sponsor_media" [alt]="center.short_name">
              <iframe *ngIf="sponsorYouTubeUrl" [src]="sponsorYouTubeUrl" [title]="center.name" frameborder="0"
                      width="560" height="315"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
              </iframe>
            </div>
          </figure>
        </div>

      </div>

    </div>
  </div>

</main>

<app-subscription-form *ngIf="!user"></app-subscription-form>
